import React from 'react'
import Draggable from 'react-draggable'
import styled from 'styled-components'

interface IProps {
    _handleDraggableOnDrag(event, ui, rightBound): void
    _handleDraggableOnStop(event, ui, rightBound): void
    rightBound: number
    position?: { x: number; y: number }
}

const DraggableCustom = ({
    _handleDraggableOnStop,
    _handleDraggableOnDrag,
    rightBound,
    position = { x: 0, y: 0 }
}: IProps): JSX.Element => {
    const _handleOnDrag = (event, ui): void => {
        _handleDraggableOnDrag(event, ui, rightBound)
    }

    const _handleOnStop = (event, ui): void => {
        _handleDraggableOnStop(event, ui, rightBound)
    }

    return (
        <Container>
            <Draggable
                onStop={(event, ui) => _handleOnStop(event, ui)}
                onDrag={(event, ui) => _handleOnDrag(event, ui)}
                bounds={{ top: 0, left: 0, right: rightBound, bottom: 0 }}
                position={position}
            >
                <div className="drag-box draggable-cursor">
                    <div className="draggable-cursor-inner"></div>
                </div>
            </Draggable>
        </Container>
    )
}

export default DraggableCustom

const Container = styled.div`
    position: relative;
    top: -16px;
    width: 100%;
    height: 12px;
    left: -9px;

    .draggable-cursor {
        top: -4px;
        width: 20px;
        height: 20px;
        display: flex;
        border-radius: 50%;
        position: relative;
        align-items: center;
        border: 2px solid ${({ theme }) => theme['gray-600']};
        background: transparent;
        /* cursor: url('/content/plugin-drill-down-map/hand-pointer.svg'), auto; */
        cursor: pointer;

        .draggable-cursor-inner {
            width: 16px;
            height: 16px;
            border-radius: 50%;
            border: 3px solid ${({ theme }) => theme['gray-0']};
        }
    }
`
